(function() {
  'use strict';

  function MenuTodoLinkDirective() {
    function MenuTodoLinkController($scope, EventSections) {
      var ctrl = this;

      var updateTodosCount = function() {
        return EventSections.getTodoInfo()
          .then(function(result) {
            ctrl.count = result.todo;
            ctrl.hasDrafts = result.draft;
          });
      };

      updateTodosCount();

      $scope.$on('DBPullChange', function(_evt, args) {
        if (args.doc.type === 'eventSection') {
          updateTodosCount();
        }
      });

      $scope.$on('ItemReloadRequested', function(_evt, args) {
        if (args.type === 'eventSection') {
          updateTodosCount();
        }
      });
    }

    MenuTodoLinkController.$inject = [
      '$scope',
      'EventSectionsService'
    ];

    return {
      restrict: 'EA',
      templateUrl: 'app/layout/header/kz-menu-todo-link.html',
      replace: true,
      controller: MenuTodoLinkController,
      controllerAs: 'ctrl'
    };
  }

  angular.module('kzHeaderCard')
    .directive('kzMenuTodoLink', MenuTodoLinkDirective);
})();
